 export const zhCn = {
  // Common
  "common.back": "返回",
  "common.cancel": "取消",
    "common.noItems": "暂无数据",
    "common.loading": "加载中...",
  // Header
  "nav.features": "功能特色",
  "nav.howItWorks": "工作原理",
  "nav.pricing": "价格方案",
  "nav.faq": "常见问题",
  "nav.testimonials": "展示墙",
  "nav.contact": "联系我们",
  "button.getStarted": "立即开始",
  "button.loading": "加载中...",
  
  // Auth related
  "auth.signIn": "登录",
  "auth.redirecting": "正在跳转...",
  "auth.continueWithGoogle": "使用谷歌账号登录",
  "auth.continueWithGithub": "使用GitHub账号登录",
  "auth.or": "或者",
  "auth.consent.prefix": "继续操作即表示你同意我们的",
  "auth.consent.terms": "服务条款",
  "auth.consent.and": "和",
  "auth.consent.privacy": "隐私政策",
  
  // Site Title
  "site.title": "沟通制胜",
  "site.title.translated": "沟通制胜",
  
  // Hero Section
  "hero.title": "AI智能沟通助手",
  "hero.subtitle": "通过智能、情境感知的回复转变您的对话方式，帮助您在任何情况下更有效地沟通。",
  "hero.cta.primary": "免费试用",
  "hero.cta.secondary": "观看演示",
  "hero.cta.tryNow": "免费开始",
  "hero.cta.learnMore": "了解更多",
  "hero.cta.getStarted": "免费开始",
  "hero.preview.primary": "润色语气",
  "hero.preview.secondary": "翻译",
  "hero.preview.tone": "友好",
  "hero.preview.target": "客户",
  "hero.hook": "加入成千上万正在提升沟通能力的用户。",
  "hero.headline": "AI 智能沟通助手",
  "hero.subheadline": "将粗糙想法快速打磨为清晰、符合上下文的高质量回复。",
  
  // Main Title
  "main.title": "将每一次回复都转化为机会",
  
  // Footer Section - 新增
  "footer.company": "公司",
  "footer.product": "产品",
  "footer.support": "支持",
  "footer.legal": "法律条款",
  "footer.contactSupport": "联系支持",
  "footer.helpCenter": "帮助中心",
  "footer.apiDocs": "API文档",
  "footer.statusPage": "服务状态",
  "footer.privacyPolicy": "隐私政策",
  "footer.termsOfService": "服务条款",
  "footer.cookiePolicy": "Cookie政策",
  "footer.refundPolicy": "退款政策",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "客服支持",
  
  // Features Section
  "features.badge": "强大功能",
  "features.title": "更好沟通所需的一切",
  "features.subtitle": "全面的工具设计，让每一次对话都更有效、更专业。",
  "features.scenario.title": "场景模板",
  "features.scenario.description": "为职场、个人、学术和专业沟通预建的模板。",
  "features.custom.title": "自定义输入",
  "features.custom.description": "粘贴任何消息或内容，获得符合上下文的适当回复。",
  "features.instant.title": "将回复时间缩短 90%",
  "features.instant.description": "在几秒内获得AI精心制作的回复。无需等待，立即获得结果。",
  "features.copy.title": "一键复制和分享",
  "features.copy.description": "即时复制回复或直接从平台分享。",
  
  // How It Works Section
  "howItWorks.badge": "工作原理",
  "howItWorks.title": "三个简单步骤实现更好沟通",
  "howItWorks.subtitle": "我们的简化流程让您轻松为任何情况生成专业回复。",
  "howItWorks.step1.title": "选择场景",
  "howItWorks.step1.description": "选择最适合您需求的沟通场景。",
  "howItWorks.step2.title": "粘贴内容",
  "howItWorks.step2.description": "添加您需要回复的消息或内容。",
  "howItWorks.step3.title": "获得AI回复",
  "howItWorks.step3.description": "在几秒钟内收到专业的、符合上下文的回复。",
  
  // Pricing Section
  "pricing.title": "定价",
  "pricing.subtitle": "选择适合您沟通需求的方案",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/月",
  "pricing.free.description": "非常适合试用我们的服务",
  "pricing.pro.description": "专业人士和频繁用户的理想选择",
  "pricing.business.description": "适合团队和组织",
  "pricing.popular": "最受欢迎",
  "pricing.free.feature1": "每月10次回复",
  "pricing.free.feature2": "基础场景",
  "pricing.free.feature3": "定义和使用模版",
  "pricing.free.feature4": "历史回复记录",
  "pricing.pro.feature1": "每月200次回复",
  "pricing.pro.feature2": "基础+自定义场景",
  "pricing.pro.feature3": "定义和使用模版",
  "pricing.pro.feature4": "历史回复记录",
  "pricing.pro.feature5": "高级自定义",
  "pricing.business.feature1": "无限回复",
  "pricing.business.feature2": "团队协作",
  "pricing.business.feature3": "基础+自定义场景",
  "pricing.business.feature4": "定义和使用模版",
  "pricing.business.feature5": "历史回复记录",
  "pricing.business.feature6": "高级自定义",
  "pricing.cta.trial": "开始免费试用",
  "pricing.cta.subscribe": "立即订阅",
  "pricing.cta.contact": "联系销售",
  "pricing.cta.current": "当前计划",
  "pricing.currentPlan": "当前计划:",
  "pricing.endDate": "当前计划终止日期:",
  "pricing.autoRenewalDate": "当前计划自动续费日期:",
  "pricing.answersLeft": "剩余回复:",
  "pricing.planName.free": "Free 计划",
  "pricing.planName.proMonthly": "Pro 计划-月付",
  "pricing.planName.proYearly": "Pro 计划-年付",
  "pricing.planName.maxMonthly": "Enterprise 计划-月付",
  "pricing.planName.maxYearly": "Enterprise 计划-年付",
  "pricing.autoRenews": "您的回复次数将于以下日期自动续期:",
  "pricing.needMore": "需要更多回复?",
  "pricing.upgradeBelow": "请在下方升级您的计划",
  "pricing.doNotRollOver": "未用回复不会结转至下一个周期",
  "pricing.willCancelOn": "将于以下日期取消:",
  "pricing.downgradeScheduled": "已计划降级，将切换到",
  "pricing.on": "于以下日期生效:",
  "pricing.upgradeImmediateTitle": "计划已升级",
  "pricing.upgradeImmediateDesc": "您的新计划已立即生效。",
  "pricing.downgradeScheduledTitle": "降级已计划",
  "pricing.downgradeScheduledDesc": "您的计划将在下一个续费日变更。",
  "pricing.cancelScheduledTitle": "已安排取消",
  "pricing.cancelScheduledDesc": "您的订阅将在周期结束时终止。",
  "pricing.cancelResumedTitle": "已恢复续费",
  "pricing.cancelResumedDesc": "您的订阅将继续自动续费。",
  "pricing.cancelPendingDowngrade": "取消",
  "pricing.pendingDowngradeCanceledTitle": "已取消计划中的降级",
  "pricing.pendingDowngradeCanceledDesc": "您的当前计划保持不变。",
  "pricing.pendingDowngradeCancelFailedTitle": "取消失败",
  "pricing.pendingDowngradeCancelFailedDesc": "未能取消计划中的降级，请稍后再试。",
  "pricing.scheduled": "已计划",
  "pricing.cancelPendingDowngradeProcessing": "处理中...",
  "pricing.processing": "处理中...",
  "pricing.getMoreReplies": "获取更多回复次数",
  "pricing.oneTimeTitle": "一次性购买更多回复次数",
  "pricing.oneTimeAmountLabel": "金额 (USD)",
  "pricing.repliesUnit": "次回复",
  "pricing.oneTimeNotice": "您购买的回复次数仅在当月周期内有效，使用需要保持付费订阅，未使用的不会结转。",
  "pricing.cancel": "取消",
  "pricing.proceed": "继续",
  "pricing.confirmUpgradeTitle": "确认升级",
  "pricing.confirmDowngradeTitle": "确认降级",
  "pricing.confirmUpgradeDesc": "您即将升级当前计划。变更会立即生效，可能产生按比例计费。",
  "pricing.confirmDowngradeDesc": "您即将计划一次降级。当前功能将在本计费周期结束前保持有效。",
  "pricing.downgradeEffectNote": "降级不会退还当前周期费用。",
  "pricing.downgradeApplyNextCycle": "新计划将在下一次续费时自动生效。",
  "pricing.confirmCancel": "返回",
  "pricing.confirmProceedUpgrade": "立即升级",
  "pricing.confirmProceedDowngrade": "确认降级计划",
  
  // FAQ Section
  "faq.title": "常见问题",
  "faq.subtitle": "关于沟通制胜您需要了解的一切",
  "faq.q1": "支持哪些沟通场景？",
  "faq.a1": "我们支持职场沟通、人际关系、学术通信、客户服务、销售推广等多种场景。我们的AI会根据每种情况所需的上下文和语调进行调整。",
  "faq.q2": "回复生成速度有多快？",
  "faq.a2": "我们的AI在几秒内生成回复。我们在不影响质量的前提下优先考虑速度，确保您能立即获得专业回复。",
  "faq.q3": "我可以随时取消订阅吗？",
  "faq.a3": "是的，您可以随时取消订阅。没有长期承诺，您可以根据需要降级或升级您的方案。",
  "faq.q4": "我的数据安全和隐私有保障吗？",
  "faq.a4": "是的，我们实施了全面的安全措施，包括加密、访问控制和定期安全审计。您的输入内容和生成的回复会作为用户历史记录存储，以启用回复查看和模板创建等功能。您可以随时通过账户设置删除历史数据。",
  "faq.q5": "如果我的Replies数量不够用怎么办？",
  "faq.a5": "Free 用户的 Replies 数量用完后，需要等待下一个月周期自动刷新。升级为 Pro 后，如果 Replies 数量不够用，可以单独购买增加；购买增加的 Replies 仅在当月周期内有效。Enterprise 用户拥有无限 Replies。",
  "faq.q6": "支持哪些语言？",
  "faq.a6": "目前我们支持英语，计划扩展到西班牙语、法语、德语和其他主要语言。AI可以有效处理多语言沟通。",
  
  // Testimonials Section
  "testimonials.title": "展示墙",
  "testimonials.subtitle": "各类沟通公开示例，激发你的回复灵感",
  "testimonials.sarah.name": "莎拉·约翰逊",
  "testimonials.sarah.title": "营销总监",
  "testimonials.sarah.quote": "沟通制胜改变了我处理客户沟通的方式。回复专业且每周为我节省数小时时间。",
  "testimonials.michael.name": "迈克尔·陈",
  "testimonials.michael.title": "销售经理",
  "testimonials.michael.quote": "职场场景模板非常准确。自从使用这个工具以来，我的回复率提高了40%。",
  "testimonials.emily.name": "艾米丽·罗德里格斯",
  "testimonials.emily.title": "客户成功主管",
  "testimonials.emily.quote": "非常适合处理困难的客户情况。AI完美理解上下文和语调。",
  
  // Interface Elements
  "interface.generating": "正在生成回复...",
  "interface.generate": "生成AI回复",
  "interface.processing": "正在处理...",
  "interface.advancedOptions": "高级选项",
  "interface.clearInput": "清空输入",
  "interface.clearDescription": "清空描述",
  // Marquee / Logos
  "marquee.trusted": "合作/支持",
  "marquee.aria": "品牌标志",
  
  // History and Showcase
  "history.shareToShowcase": "发布到展示墙",
  "history.showcased": "已发布",
  "history.shareConfirm": "确定将此信息发布到展示墙？此操作不可撤回，除非删除该信息。",
  "history.sharedBy": "发布者：",
  "interface.copy": "复制",
  "interface.share": "分享",
  "interface.shareResponse": "分享回复",
  "interface.shareNative": "系统分享",
  "interface.shareEmail": "邮件",
  "interface.copyShareText": "复制带链接",
  "interface.shareTextCopied": "回复和链接已复制到剪贴板。",
  "interface.ready": "准备生成",
  "interface.enterMessage": "输入您的消息内容并选择场景，开始使用AI驱动的回复。",
  "interface.fast": "快速",
  "interface.accurate": "准确",
  "interface.professional": "专业",
  "interface.translation": "翻译",
  "interface.responseDescription": "这里有一个深思熟虑和专业的回复，适合当前的上下文：",
  "interface.multipleOptions": "多个回复选项：",
  "interface.option": "选项",
  "interface.viewOriginal": "查看原文",
  "interface.originalMessage": "消息原文",
  "interface.noContent": "暂无内容",
  
  // Placeholders
  "placeholder.message": "粘贴您要回复的消息、邮件内容或收到的文本...",
  
  // Dropdowns
  "dropdown.useTemplates": "使用模版",
  "dropdown.scenario": "无场景",
  "dropdown.target": "无目标",
  "dropdown.tone": "无语气",
  
  // Scenario Options
  "scenario.email": "邮件",
  "scenario.message": "消息",
  "scenario.workplace": "职场",
  "scenario.school": "学校",
  "scenario.home": "家庭",
  "scenario.business": "商务",
  "scenario.academic": "学术",
  "scenario.social": "社交",
  "scenario.formal": "正式",
  "scenario.casual": "随意",
  "scenario.professional": "专业",
  "scenario.personal": "个人",
  "scenario.customerService": "客户服务",
  "scenario.interview": "面试",
  "scenario.presentation": "演示",
  
  // Target Options
  "target.lover": "恋人",
  "target.friend": "朋友",
  "target.boss": "老板",
  "target.colleague": "同事",
  "target.classmate": "同学",
  "target.parents": "父母",
  "target.child": "孩子",
  "target.teacher": "老师",
  "target.student": "学生",
  "target.client": "客户",
  "target.customer": "顾客",
  "target.stranger": "陌生人",
  "target.family": "家人",
  "target.sibling": "兄弟姐妹",
  "target.neighbor": "邻居",
  "target.mentor": "导师",
  "target.supplier": "供应商",
  "target.serviceProvider": "服务提供商",
  "target.partner": "合作伙伴",
  "target.subordinate": "下属",
  
  // Tone Options
  "tone.humorous": "幽默",
  "tone.serious": "严肃",
  "tone.happy": "开心",
  "tone.angry": "愤怒",
  "tone.mischievous": "调皮",
  "tone.polite": "礼貌",
  "tone.casual": "随意",
  "tone.formal": "正式",
  "tone.friendly": "友好",
  "tone.confident": "自信",
  "tone.apologetic": "道歉",
  "tone.enthusiastic": "热情",
  
  // Status Messages
  "status.copied": "已复制！",
  "status.copyDescription": "回复已复制到剪贴板。",
  "status.copyWithTranslationDescription": "回复和翻译已复制到剪贴板。",
  "status.success": "回复生成成功。",
  "status.successWithTranslation": "回复生成成功，并带有翻译。",
  "status.successWithoutTranslation": "回复生成成功。",
  "status.error": "生成失败",
  "status.errorDescription": "生成回复失败。请重试。",
  "status.enterContent": "请输入内容",
  "status.enterContentDescription": "添加您要回复的消息。",
  
  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "描述 (可选)",
  "restriction.descriptionLabel": "描述 (仅限Pro / Enterprise订阅者)",
  "restriction.proMaxOnly": "* 仅限Pro / Enterprise订阅者",
  "restriction.desPrompt": "输入上下文、背景信息或具体要求，以帮助生成更好的回复…",
  
  // Demo functionality for non-logged-in users
  "demo.title": "选择要回复的消息",
  "demo.option1": "销售开场白（冷联系）",
  "demo.option2": "处理\"你们价格太高\"的探询",
  "demo.option3": "面试自我介绍（30秒版本）",
  "demo.option4": "邮件回复",
  "demo.option5": "对\"已读不回\"客户的跟进",
  "demo.option6": "电梯演讲（30秒）",
  "demo.runDemo": "运行演示",
  "demo.inputContent": "输入内容：",
  "demo.scenario": "场景：",
  "demo.target": "目标：",
  "demo.tone": "语气：",
  "demo.description": "描述：",

  // Showcase Page
  "showcase.title": "展示墙",
  "showcase.subtitle": "浏览社区分享的 AI 优化沟通示例，获取灵感",
  "showcase.userPrefix": "该用户公开的沟通：",
  "showcase.backAll": "返回全部展示",
  "showcase.sortBy": "排序：",
  "showcase.sort.newest": "最新优先",
  "showcase.sort.oldest": "最早优先",
  "showcase.sort.scenario": "按场景",
  "showcase.sort.target": "按对象",
  "showcase.sort.tone": "按语气",
  "showcase.filter.scenario": "场景：",
  "showcase.filter.target": "对象：",
  "showcase.filter.tone": "语气：",
  "showcase.filter.all": "全部",
  "showcase.loading": "正在加载展示内容...",
  "showcase.loadingUser": "正在加载该用户的公开沟通...",
  "showcase.loadingMore": "加载更多...",
  "showcase.none.userTitle": "暂无公开沟通",
  "showcase.none.globalTitle": "暂无展示内容",
  "showcase.none.userDesc": "该用户尚未分享任何内容到展示墙。",
  "showcase.none.globalDesc": "快来成为第一个分享 AI 沟通示例的人！",
  "showcase.messageDetails": "消息详情",
  "showcase.field.date": "日期",
  "showcase.field.scenario": "场景",
  "showcase.field.target": "对象",
  "showcase.field.tone": "语气",
  "showcase.originalMessage": "原始消息",
  "showcase.description": "描述",
  "showcase.aiResponse": "AI 回复",

  // Templates
  "templates.saveAsTemplate": "保存为模板",
  "templates.saved": "模板已保存",
  "templates.saveSuccess": "模板保存成功",
  "templates.title": "我的模板",
  "templates.new": "新建模板",
  "templates.loading": "加载中...",
  "templates.none": "暂无模板",
  "templates.name": "名称",
  "templates.scenario": "场景",
  "templates.target": "对象",
  "templates.tone": "语气",
  "templates.description": "描述",
  "templates.save": "保存",
  "templates.saving": "正在保存...",
  "templates.delete": "删除模板",
  "templates.deleteConfirm": "确定删除该模板？",
  "templates.deleteFailed": "删除模板失败",
  "templates.nameRequired": "* 请输入模板名称",
  "templates.deleteSuccess": "模板已删除",

  // History Modal additions
  "history.messageDetails": "消息详情",
  "history.messageDetailsDesc": "查看和管理消息详情，包括原始输入和 AI 生成的回复。",
  "history.field.date": "日期",
  "history.field.scenario": "场景",
  "history.field.target": "对象",
  "history.field.tone": "语气",
  "history.originalMessage": "原始消息",
  "history.aiResponse": "AI 回复",
  "history.description": "描述",
  "history.listTitle": "历史记录",
  "history.listDesc": "浏览、筛选并管理你的历史对话，点击任意消息查看详情。",
  "history.sortBy": "排序：",
  "history.sort.newest": "最新优先",
  "history.sort.oldest": "最早优先",
  "history.sort.scenario": "按场景",
  "history.sort.target": "按对象",
  "history.sort.tone": "按语气",
  "history.filter.scenario": "场景：",
  "history.filter.target": "对象：",
  "history.filter.tone": "语气：",
  "history.filter.all": "全部",
  "history.loading": "加载历史记录...",
  "history.loadingMore": "正在加载更多...",
  "history.none": "暂无消息记录",
  "history.showing": "已显示 {current} / {total} 条",
  "history.allLoaded": "已加载全部记录",
  "history.scrollMore": "下拉加载更多",
  "history.deleteMessage": "删除消息",
  "history.deleting": "正在删除...",
  "history.deleteSuccess": "消息记录已删除",
  "history.deleteFailed": "删除失败，请重试",
  "history.confirmDeleteTitle": "确认删除",
  "history.confirmDeleteSubtitle": "该操作不可恢复",
  "history.confirmDeleteDesc": "确定要删除这条消息记录吗？",
  "history.confirmDeleteAction": "确认删除",
  "history.shareTitle": "分享到展示墙",
  "history.shareSubtitle": "将此消息设为公开",
  "history.sharing": "正在分享...",
  "history.confirmShareAction": "确认分享",
  "history.shareSuccess": "已成功分享到展示墙",
  "history.shareFailed": "分享失败，请重试",
  "templates.saveFailed": "模板保存失败",

  // User Menu
  "userMenu.myAccount": "我的账户",
  "userMenu.history": "历史记录",
  "userMenu.templates": "我的模板",
  "userMenu.signOut": "退出登录",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "AI 回复预览",
  "hero.preview.scenarioLabel": "场景",
  // Demo 标签简短标题
  "demo.shortTitle.salesOpener": "销售开场",
  "demo.shortTitle.priceObjection": "价格探询",
  "demo.shortTitle.interviewIntro": "面试开场",
  "demo.shortTitle.emailReply": "邮件回复",
  "demo.shortTitle.followUp": "跟进",
  "demo.shortTitle.elevatorPitch": "电梯陈述",
  // Demo 路径与右上角 response 标签
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "response",
  "demoTabs.inputPrompt": "输入提示",
  "demoTabs.context": "上下文",
  "demoTabs.description": "描述",
  "demoTabs.generate": "生成",
  "demoTabs.aiOutput": "AI 输出",
  "demoTabs.sample": "示例",
  "demoTabs.streaming": "正在流式生成…",
  "preview.section.scenarioTemplates.title": "场景 & 模板",
  "preview.section.scenarioTemplates.subtitle": "快速选择场景或应用已保存模板，自动预填描述/对象/语气，高质量生成即刻开始。",
  "preview.section.customInputs.title": "自定义输入",
  "preview.section.customInputs.subtitle": "核心输入 + 可选描述 + 高级场景/对象/语气选择器，自由组合获取情境化结果。",
  "preview.section.cutReplyTime.title": "将回复时间缩短 90%",
  "preview.section.cutReplyTime.subtitle": "对比人工撰写与 AI 辅助：并行选项 + 内置翻译与修改循环。",
  "preview.section.copyShare.title": "一键复制和分享",
  "preview.section.copyShare.subtitle": "多种选项统一布局：复制全部 / 分享 / 单条复制。复制全部时自动附加翻译。",
  "preview.templates.my": "我的模板",
  "preview.templates.new": "新建",
  "preview.manualFlow": "人工流程",
  "preview.aiAssisted": "AI 辅助",
  // 人工流程项目
  "preview.manualFlow.step1": "规划结构与语气",
  "preview.manualFlow.step2": "起草开场 / 删除重写",
  "preview.manualFlow.step3": "调整礼貌与语法",
  "preview.manualFlow.step4": "查词并核对翻译",
  "preview.manualFlow.step5": "粘贴到目标应用",
  "preview.copyAll": "复制全部",
  "preview.share": "分享",
  "preview.enPlusTranslation": "英文 + 翻译",
  "preview.translationAppendNote": "(*) 复制全部时会自动附加翻译。",
  "preview.field.scenario": "场景",
  "preview.field.target": "对象",
  "preview.field.tone": "语气",
  "preview.auto": "自动",
  "preview.step.pasteOrTemplate": "粘贴请求或选择模板",
  "preview.step.optionalDescription": "(可选) 添加描述/场景",
  "preview.step.pickOption": "选择生成的一个选项",
  "preview.step.copyShareTranslate": "一键复制 / 分享 / 翻译",
  "preview.time.manual": "5–8 分钟",
  "preview.time.ai": "30–40 秒"
};